import React from 'react';
import './App.css';
import Hero from './components/Hero';
import Bio from './components/Bio';
// import MediaGallery from './components/MediaGallery';
import MusicStore from './components/MusicStore';
import Merch from './components/Merch';
import Social from './components/Social';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Hero />
      <Bio />
      {/* <MediaGallery /> */}
      <MusicStore />
      <Merch />
      <Social />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
